import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { LogIn } from 'lucide-react';
import { useState } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { LoginPageTestIds } from '../../../utils/testIds/LoginPage.testIds';
import { useTranslation } from '../../translation/TranslationContext';
import { useAuthContext } from '../AuthContext';
import ConnectAccountModal from '../ConnectAccountModal';

interface PublicLoginButtonProps {
  brandSlug?: string;
}

const PublicLoginButton = ({ brandSlug }: PublicLoginButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { translate } = useTranslation();
  const { loggedin } = useAuthContext();

  if (loggedin) {
    return null;
  }

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        size="medium"
        shape="square"
        testId={LoginPageTestIds.PUBLIC_LOGIN_BUTTON}
        startIcon={<Icon icon={LogIn} size="md" />}
        onClick={() => setIsOpen(true)}
      >
        {translate(LangEnum.LOGIN_LOGIN)}
      </Button>

      <ConnectAccountModal open={isOpen} brandSlug={brandSlug} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default PublicLoginButton;
